import { authContext, adalConfig } from '../config/adalConfig';

export const getToken = () => authContext.getCachedToken(adalConfig.clientId);

export const getAuthUser = () => authContext.getCachedUser();

export const onLogOut = () => authContext.logOut();
